import { useNavigate, useLocation } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

const LanguageToggle = () => {
  const lang = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  const toggle = () => {
    if (lang === "fi") {
      navigate("/en" + location.pathname);
    } else {
      navigate(location.pathname.replace(/^\/en/, "") || "/");
    }
  };

  return (
    <button
      onClick={toggle}
      className="absolute top-4 right-4 md:top-6 md:right-6 z-10 bg-primary-foreground/20 backdrop-blur-sm text-primary-foreground border border-primary-foreground/30 px-3 py-1.5 rounded-full text-xs font-semibold hover:bg-primary-foreground/30 transition-colors"
      aria-label={lang === "fi" ? "EN – Switch to English" : "FI – Vaihda suomeksi"}
    >
      {lang === "fi" ? "EN 🇬🇧" : "FI 🇫🇮"}
    </button>
  );
};

export default LanguageToggle;
